import axios from '@axios'

const PIPELINE_PREFIX = '/pipelines'
const STAGES_PREFIX = '/stages'
const DEALS_PREFIX = '/deals'

export default {

  /// Pipelines
  getActivePipelines() {
    return axios.get(`${PIPELINE_PREFIX}`)
  },
  getPipelineWithStangesAndDeals(pipelineId) {
    return axios.get(`${PIPELINE_PREFIX}/${pipelineId}/completo`)
  },
  createPipeline(data) {
    return axios.post(`${PIPELINE_PREFIX}`, data)
  },

  /// Stages
  getStagesAndDeals(pipelineId) {
    return axios.get(`${STAGES_PREFIX}/pipelines/${pipelineId}?include=stages,deals:recent`)
  },
  createPipelineStage(pipelineId, data) {
    return axios.post(`${STAGES_PREFIX}/pipelines/${pipelineId}`, data)
  },
  updatePipelineStageOrder(stageId, newOrder) {
    return axios.put(`${STAGES_PREFIX}/${stageId}/order/${newOrder}`)
  },
  deletePipelineStage(stageId) {
    return axios.delete(`${STAGES_PREFIX}/${stageId}`)
  },

  /// Deals
  createDeal(stageId, data) {
    return axios.post(`${DEALS_PREFIX}/stages/${stageId}`, data)
  },
  updateDeal(dealId, newStageId, newOrder = null) {
    const payload = {
      DealId: dealId,
      NewStageId: newStageId,
      NewOrder: newOrder,
    }
    return axios.patch(`${DEALS_PREFIX}/${dealId}/move`, payload)
  },
  getDealProposals(dealId) {
    return axios.get(`${DEALS_PREFIX}/${dealId}/propostas`)
  },

  // Deal Notes
  getDealNotes(dealId) {
    return axios.get(`${DEALS_PREFIX}/${dealId}/notas`)
  },
  createDealNote(dealId, data) {
    return axios.post(`${DEALS_PREFIX}/${dealId}/notas`, data)
  },

  // Delete a note by id
  deleteDealNote(noteId) {
    return axios.delete(`${DEALS_PREFIX}/notas/${noteId}`)
  },
}
